// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1SNc7","title":"ClientCherryInfo_title__2mpiK","itemText":"ClientCherryInfo_itemText__2bfVR"};